<template>
  <div>
    <!-- <loading :active.sync="isLoading"></loading> -->
    <nav class="nav">
      <div class="nav__logo" @click.prevent="gohome()">
        <img src="@/assets/image/logo.png" alt="Logo" class="nav__logo--img" />
      </div>

      <div class="nav__menu">
        <div class="nav__menu--sub" v-for="(item,index) in function_list" :key="index">
          <span href="#" @click.prevent="goTask(item)">{{item}}</span>
        </div>
      </div>

      <div class="dropdown show">
        <a
          class="nav__account"
          href="#"
          id="dropdownMenuLink"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >{{email}}</a>

        <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
          <a class="dropdown-item" href="#">Profile</a>
          <a class="dropdown-item" href="#" @click.prevent="logout">Logout</a>
        </div>
      </div>
      <div class="nav__role">{{role}}</div>
    </nav>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // isLoading: false,
      email: localStorage.email,
      role: localStorage.role,
      function_list: [],
    };
  },
  methods: {
    goTask(data) {
      if (data === 'Task') {
        this.$router.push('/task');
      } else if (data === 'Dataset') {
        this.$router.push('/dataset');
      } else if (data === 'CheckTools') {
        this.$router.push('/check');
      } else if (data === 'ModelReport') {
        this.$router.push('/report');
      } else if (data == 'Account') {
        this.$router.push('/account');
      }
    },
    gohome() {
      this.goTask('Task');
    },
    logout() {
      //   this.isLoading = true;
      this.$store.dispatch('Logout').then((res) => {
        // console.log(res)
        if (res === '') {
          this.$router.push('/login');
        }
        // this.isLoading = false;
      });
    },
  },
  mounted() {
    const vm = this;
    const functions = ['Task'];
    functions.push('Dataset');
    if (localStorage.role === 'admin') {
      functions.push('CheckTools');
      functions.push('ModelReport');
      functions.push('Account');
    }
    vm.function_list = functions;
  },
};
</script>
